"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _alphapointApexApi = require("alphapoint-apex-api");
var _wsHelper = require("../../helpers/wsHelper");
var _tickerHelper = require("../../helpers/tickerHelper");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* global $ */ /*
 This class implements interaction with UDF-compatible datafeed.

 See UDF protocol reference at
 https://github.com/tradingview/charting_library/wiki/UDF
 */
var ChartAPI = {};
var UDFCompatibleDatafeed = /*#__PURE__*/_createClass(function UDFCompatibleDatafeed(datafeedURL, protocolVersion, customGateway, currentTimezone, getDecimalPlaces) {
  var _this = this;
  _classCallCheck(this, UDFCompatibleDatafeed);
  _defineProperty(this, "buildBar", function (barData) {
    var barValue = {
      time: barData[9],
      high: barData[1],
      low: barData[2],
      open: barData[3],
      close: barData[4],
      volume: barData[5]
    };
    return barValue;
  });
  _defineProperty(this, "getBars", function (symbolInfo, resolution, rangeStartEndDate, onDataCallback) {
    var that = _this;
    var from = rangeStartEndDate.from,
      to = rangeStartEndDate.to,
      firstDataRequest = rangeStartEndDate.firstDataRequest;
    if (rangeStartEndDate.from > 0 && "".concat(rangeStartEndDate.from).length > 10) {
      throw new Error("Got a JS time instead of Unix one. rangeStartDate: ".concat(rangeStartEndDate.from, ", rangeEndDate: ").concat(rangeStartEndDate.to));
    }
    var interval = (0, _tickerHelper.convertLabelToTickerInterval)(resolution);
    var newIntervalMs = interval * 1000;
    var req = {};
    req.OMSId = symbolInfo.omsId;
    req.InstrumentId = symbolInfo.instrumentId;
    _this.ws.RPCCall("UnSubscribeTicker", _this.unsubscribeReqObj);
    _this.unsubscribeReqObj.InstrumentId = req.InstrumentId;
    req.Interval = interval; // interval is seconds
    req.FromDate = new Date(from * 1000).toJSON().split(".")[0].split("T").join(" ");
    req.ToDate = new Date(to * 1000).toJSON().split(".")[0].split("T").join(" ");
    req.IncludeLastCount = 5000;
    _this.subscriptionIntervalMs = newIntervalMs;
    _this.subscribeReqObj.OMSId = symbolInfo.omsId;
    _this.subscribeReqObj.InstrumentId = symbolInfo.instrumentId;
    _this.subscribeReqObj.Interval = interval; // interval is seconds
    _this.subscribeReqObj.IncludeLastCount = 5000;
    that.ws.RPCCall('GetTickerHistory', req, function () {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      data = JSON.parse(data.o);
      var noData = !data.length;
      var bars = [];
      var barsCount = data.length;
      for (var i = 0; i < barsCount; ++i) {
        var barData = data[i];
        var barValue = that.buildBar(barData);
        bars.push(barValue);
      }
      if (barsCount > 0) {
        _this.gotBars = symbolInfo.name;
        _this.lastBar = bars[bars.length - 1];
      } else {
        _this.lastBar = null;
      }
      onDataCallback(bars, {
        version: that._protocolVersion,
        noData: noData,
        nextTime: data.nb || data.nextTime || null
      });

      // Prevent looping when exiting a specified period of time
      var filteredBars = bars.filter(function (item) {
        return item.time >= rangeStartEndDate.from * 1000 && item.time <= rangeStartEndDate.to * 1000;
      });
      if (filteredBars.length === 0) {
        onDataCallback([], {
          version: that._protocolVersion,
          noData: true,
          nextTime: null
        });
      }
    });
  });
  _defineProperty(this, "onMessage", function (event) {
    var synchroCallBack = _this._amsynchro[event.i];
    if (synchroCallBack === undefined) {
      if (event.n === 'TickerDataUpdateEvent') {
        var data = JSON.parse(event.o);
        if (_this.callback !== undefined && _this.callback !== null) {
          var newBar = _this.buildBar(data[0]);
          if (_this.lastBar !== null) {
            if (_this.lastBar.time > newBar.time) {
              newBar.time = _this.lastBar.time;
            }
          }
          _this.callback(newBar);
          _this.lastBar = newBar;
        }
      }
    } else if (event.o === '') {
      synchroCallBack({});
    } else if (synchroCallBack != null) {
      synchroCallBack(JSON.parse(event.o));
    }
  });
  _defineProperty(this, "defaultConfiguration", function () {
    return {
      supports_search: true,
      supports_group_request: false,
      supported_resolutions: [1, 5, 15, 30, 60, 360, 720, '1D', '1W', '1M'],
      supports_marks: false,
      supports_timescale_marks: false
    };
  });
  _defineProperty(this, "getServerTime", function (callback) {
    if (_this._configuration.supports_time) {
      _this._send("".concat(_this._datafeedURL, "/time"), {}).done(function (response) {
        callback(+response);
      }).fail(function () {});
    }
  });
  _defineProperty(this, "on", function (event, callback) {
    if (!Object.prototype.hasOwnProperty.call(_this._callbacks, event)) {
      _this._callbacks[event] = [];
    }
    _this._callbacks[event].push(callback);
    return _this;
  });
  _defineProperty(this, "onInitialized", function () {
    _this._initializationFinished = true;
    _this._fireEvent('initialized');
  });
  _defineProperty(this, "onReady", function (callback) {
    var that = _this;
    if (_this._configuration) {
      setTimeout(function () {
        callback(that._configuration);
      }, 0);
    } else {
      _this.on('configuration_ready', function () {
        callback(that._configuration);
      });
    }
  });
  // BEWARE: this function does not consider symbol's exchange
  _defineProperty(this, "resolveSymbol", function (symbolName, onSymbolResolvedCallback, onResolveErrorCallback) {
    var symbol = {};
    var instrument = _this.instrumentsArray && _this.instrumentsArray.filter(function (i) {
      return i.Symbol === symbolName;
    })[0];
    if (instrument) {
      // might be DEPRICATED, but anyway can help
      // https://github.com/alphapoint/charting_library_wiki
      var currentDecimalPlaces = _this._getDecimalPlaces(instrument.PriceIncrement) || 2;
      symbol.omsId = instrument.OMSId;
      symbol.name = instrument.Symbol;
      symbol.full_name = instrument.Symbol;
      symbol.description = instrument.Symbol;
      symbol.instrumentId = instrument.InstrumentId;
      symbol.ticker = instrument.Symbol;
      symbol.minmov = 1;
      symbol.pricescale = Math.pow(10, currentDecimalPlaces); // responsible for decimal places for axis`s numbers
      symbol.timezone = 'UTC';
      symbol.session = '24x7';
      symbol.has_intraday = true;
      symbol.intraday_multipliers = ['1', '5', '15', '30', '60', '120', '240', '360', '720'];
      symbol.has_daily = true;
      symbol.volume_precision = 2;
      symbol.visible_plots_set = 'ohlcv';
      symbol.data_status = 'streaming';
      setTimeout(function () {
        onSymbolResolvedCallback(symbol);
      }, 0);
    } else if (_this._symbolRetries < 10) {
      _this._symbolRetries++;
      console.log("Symbol resolve retry #".concat(_this._symbolRetries));
      setTimeout(function () {
        _this.resolveSymbol(symbolName, onSymbolResolvedCallback, onResolveErrorCallback);
      }, 100);
    } else {
      onResolveErrorCallback("Could not resolve ".concat(symbolName, " after ").concat(_this._symbolRetries, " retries"));
    }
  });
  _defineProperty(this, "searchSymbolsByName", function () {});
  _defineProperty(this, "searchSymbols", function (searchString, exchange, type, onResultReadyCallback) {
    var MAX_SEARCH_RESULTS = 30;
    if (!_this._configuration) {
      onResultReadyCallback([]);
      return;
    }
    if (_this._configuration.supports_search) {
      _this._send("".concat(_this._datafeedURL, "/search"), {
        limit: MAX_SEARCH_RESULTS,
        query: searchString.toUpperCase(),
        type: type,
        exchange: exchange
      }).done(function (response) {
        var data = JSON.parse(response);
        for (var i = 0; i < data.length; ++i) {
          if (!data[i].params) {
            data[i].params = [];
          }
        }
        if (typeof data.s === 'undefined' || data.s !== 'error') {
          onResultReadyCallback(data);
        } else {
          onResultReadyCallback([]);
        }
      }).fail(function (reason) {
        onResultReadyCallback([]);
        throw new Error(reason);
      });
    } else {
      if (!_this._symbolSearch) {
        throw new Error('Datafeed error: inconsistent configuration (symbol search)');
      }
      var searchArgument = {
        searchString: searchString,
        exchange: exchange,
        type: type,
        onResultReadyCallback: onResultReadyCallback
      };
      if (_this._initializationFinished) {
        _this._symbolSearch.searchSymbols(searchArgument, MAX_SEARCH_RESULTS);
      } else {
        var that = _this;
        _this.on('initialized', function () {
          that._symbolSearch.searchSymbols(searchArgument, MAX_SEARCH_RESULTS);
        });
      }
    }
  });
  _defineProperty(this, "subscribeBars", function (symbolInfo, resolution, onRealtimeCallback) {
    _this.callback = onRealtimeCallback;
    var subscribereq = _this.subscribeReqObj;
    _this.ws.RPCCall('SubscribeTicker', subscribereq);
  });
  _defineProperty(this, "unsubscribeBars", function () {
    //const req = this.unsubscribeReqObj;
    //this.ws.RPCCall('UnsubscribeTicker', req);
  });
  _defineProperty(this, "_setupWithConfiguration", function (configurationData) {
    _this._configuration = configurationData;
    if (!_this._configuration.exchanges) {
      _this._configuration.exchanges = [];
    }

    // @obsolete; remove in 1.5
    var supportedResolutions = _this._configuration.supported_resolutions || _this._configuration.supportedResolutions;
    _this._configuration.supported_resolutions = supportedResolutions;

    // @obsolete; remove in 1.5
    var symbolsTypes = _this._configuration.symbols_types || _this._configuration.symbolsTypes;
    _this._configuration.symbols_types = symbolsTypes;
    if (!_this._configuration.supports_search && !_this._configuration.supports_group_request) {
      throw new Error('Unsupported datafeed configuration. Must either support search, or support group request');
    }
    if (!_this._configuration.supports_search) {
      _this._symbolSearch = new ChartAPI.SymbolSearchComponent(_this);
    }
    if (_this._configuration.supports_group_request) {
      // this component will call onInitialized() by itself
      // this._symbolsStorage = new ChartAPI.SymbolsStorage(this);
    } else {
      _this.onInitialized();
    }
    _this._fireEvent('configuration_ready');
    _this._logMessage("Initialized with ".concat(JSON.stringify(configurationData)));
  });
  _defineProperty(this, "_initialize", function () {
    _this._setupWithConfiguration(_this.defaultConfiguration());
    _this.ws.ws.filter(function (x) {
      return x.n === 'TickerDataUpdateEvent';
    }).subscribe(function (data) {
      data = data.o;
      if (_this.callback !== null) {
        var newBar = _this.buildBar(data[0]);
        if (_this.lastBar !== null && newBar && typeof newBar.time !== 'string') {
          if (newBar.time - _this.subscriptionIntervalMs < _this.lastBar.time) {
            newBar.time = _this.lastBar.time;
          }
          _this.callback(newBar);
          _this.lastBar = newBar;
        }
      }
    });
  });
  _defineProperty(this, "_fireEvent", function (event, argument) {
    if (Object.prototype.hasOwnProperty.call(_this._callbacks, event)) {
      var callbacksChain = _this._callbacks[event];
      for (var i = 0; i < callbacksChain.length; ++i) {
        callbacksChain[i](argument);
      }
      _this._callbacks[event] = [];
    }
  });
  _defineProperty(this, "_logMessage", function (message) {
    if (_this._enableLogging) {
      console.log(message, new Date());
    }
  });
  _defineProperty(this, "_send", function (url, params) {
    var request = url;
    if (params) {
      for (var i = 0; i < Object.keys(params).length; ++i) {
        var key = Object.keys(params)[i];
        var value = encodeURIComponent(params[key]);
        request += "".concat((i === 0 ? '?' : '&') + key, "=").concat(value);
      }
    }
    _this._logMessage("New request: ".concat(request));
    return $.ajax({
      type: 'GET',
      url: request,
      contentType: 'text/plain'
    });
  });
  this._amsynchro = {};
  this._callbacks = {};
  this._configuration = undefined;
  this._datafeedURL = datafeedURL;
  this._enableLogging = false;
  this._initializationFinished = false;
  this._historyURL = '/history';
  this._protocolVersion = protocolVersion || 2;
  this._symbolSearch = null;
  this._symbolsStorage = null;
  this._symbolResolveURL = '/symbols';
  this._symbolRetries = 0;
  this._timezone = currentTimezone;
  this._getDecimalPlaces = getDecimalPlaces.bind(this);
  this.callback = null;
  this.connected = false;
  this.lastBar = null;
  this.unsubscribeReqObj = {
    OMSId: 1,
    InstrumentId: 0
  };
  this.subscribeReqObj = {};
  this.gotBars = '';
  this.subscriptionIntervalMs = 0;
  var onopen = this._initialize.bind(this);
  this.ws = new _alphapointApexApi.APEX(customGateway ? customGateway : (0, _wsHelper.getGateway)(), {
    onopen: onopen
  });
  this.ws.getInstruments(function (data) {
    _this.instrumentsArray = JSON.parse(data.o);
  });
  this.ws.ws.filter(function (x) {
    return x.n === 'TickerDataUpdateEvent';
  }).subscribe(function (response) {
    _this.onMessage(response);
  });
});
ChartAPI.UDFCompatibleDatafeed = UDFCompatibleDatafeed;
var _default = exports["default"] = ChartAPI;